import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Link} from 'react-router-dom'
import {getFilterEventsList} from '../../actions/eventsActions';
import config from "../../utils/config.json"
import {Card, CardImg, CardBlock,CardSubtitle,Row, Col,Alert} from 'reactstrap';

class Events extends Component {
  componentDidMount() {
    let {getFilterEventsList, limit} = this.props
    let {data} = this.props.events

    if (data === null) {
      getFilterEventsList(limit);
    }
  }

  render() {
    let {fetching, data} = this.props.events
    let {fetchingsearch, datasearch} = this.props.events.search

    const description = {
      width: '100%',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 4,
      overflow: 'hidden',
      fontSize: '15px',
      margin: '20px 0 20px 0',
      height: '90px',
    };
   

    return (
      <div>
       {fetchingsearch ?
          <div>
            {fetching ?
              <div>Loading ...</div>
              :
              <Row>
                {data && data.map((item, key) => (
                  <Col xs="12" md="3" className="mb-4" key={key}>
                    <Link className="events-link"to={`/events/${item.id}`}>
                      <Card className="events">
                        <CardImg top height="180px" src={`${config.shopUrl}/img/images/${item.id}.jpg`} alt={item.name}/>
                        <CardBlock>
                        <div className="events-height">
                          <CardSubtitle className="card-event-title">
                            <strong className="link">
                             {item.title}
                            </strong>
                          </CardSubtitle>
                        </div>
                          <p style={description} dangerouslySetInnerHTML={{__html: item.short_description}} />
                          <div className="savoir-plus">
                            <Link to={`/events/${item.id}`}>
                               En savoir +
                            </Link>
                          </div>
                        </CardBlock>
                      </Card>
                    </Link>
                  </Col>
                ))}
              </Row>
            }
          </div>
          :
          <div>
           {datasearch ?
            <Row>
           

              {datasearch && datasearch.map((item, key) => (
                <Col xs="12" md="3" className="mb-4" key={key}>
                  <Link className="events-link"to={`/events/${item.id}`}>
                    <Card className="events">
                      <CardImg top height="180px" src={`${config.shopUrl}/img/images/${item.id}.jpg`} alt={item.name}/>
                      <CardBlock>
                      <div className="events-height">
                        <CardSubtitle className="card-event-title">
                          <strong className="link">
                           {item.title}
                          </strong>
                        </CardSubtitle>
                      </div>
                        <p style={description} dangerouslySetInnerHTML={{__html: item.short_description}} />
                        <div className="savoir-plus">
                          <Link to={`/events/${item.id}`}>
                             En savoir +
                          </Link>
                        </div>
                      </CardBlock>
                    </Card>
                  </Link>
                </Col>
              ))}
             
            </Row>
            :
            <Alert color="warning" className="mt-4 ml-4 mr-4">
                    Il n’y a aucun formation correspondant à votre recherche.
              </Alert>
            }
          </div>
       }
       </div>
    )
  }
}


function mapStateToProps({eventsReducer}) {
  return {
    events: eventsReducer
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getFilterEventsList: bindActionCreators(getFilterEventsList, dispatch),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Events);


// WEBPACK FOOTER //
// ./src/components/events/Events.js